import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, ShieldCheck, ArrowUpRight } from "lucide-react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { PageLoading } from "../../components/States";
import { api } from "../../lib/api";
import { setPageTitle } from "../../lib/format";

// Security user's home: ONLY the properties a host has explicitly shared with
// this account. No Host/Commercial administration surfaces leak into this view.
export default function SecurityHome() {
  const [props_, setProps] = useState(null);
  useEffect(() => {
    setPageTitle("Shared Properties");
    api.securitySharedProperties().then(setProps).catch(() => setProps([]));
  }, []);

  return (
    <div className="min-h-screen flex flex-col" data-testid="security-home-page">
      <Navbar />
      <main className="flex-1 max-w-4xl w-full mx-auto px-5 sm:px-8 pt-28 pb-16">
        <p className="section-label">Security</p>
        <h1 className="type-display mt-3">Shared Properties</h1>
        <p className="mt-1 text-sm text-zinc-400">Live operational access granted to you by property owners.</p>
        {!props_ ? (
          <div className="mt-10"><PageLoading label="Loading shared properties…" /></div>
        ) : props_.length === 0 ? (
          <div className="mt-10 card-dark p-10 text-center" data-testid="security-home-empty">
            <Building2 className="w-8 h-8 text-zinc-600 mx-auto" />
            <p className="mt-4 font-display text-lg text-white">No properties shared with you yet</p>
            <p className="mt-1 text-sm text-zinc-500">When a property owner grants you security access, it appears here.</p>
          </div>
        ) : (
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {props_.map((p) => (
              <Link key={p.property_id} to={`/security/${p.property_id}`} data-testid={`security-property-${p.property_id}`}
                    className="card-dark p-5 group hover:border-[#E50914]/40 transition-colors">
                {p.image && (
                  <div className="rounded-xl overflow-hidden aspect-[16/7] mb-4 bg-black">
                    <img src={p.image} alt="" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
                  </div>
                )}
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="font-display font-bold text-white truncate">{p.name || "Property"}</p>
                    <p className="mt-0.5 text-xs text-zinc-500 truncate">{p.address}</p>
                    <p className="mt-1 font-mono text-[11px] tracking-[0.2em] text-[#FF3B45]">#{p.property_code}</p>
                  </div>
                  <span className="shrink-0 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-zinc-300 bg-white/5 border border-[#27272A] rounded-full px-2 py-0.5">
                    <ShieldCheck className="w-3 h-3 text-[#FF3B45]" /> {p.permission}
                  </span>
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-xs text-[#FF3B45] font-semibold">
                  Open operations <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
